import { provide } from 'vue';

export default function useCreditCardFieldsContext() {
    provide('creditCardFieldsContext', {
        stripeElementsEnabled: false,
        stripeElementsUrl: window.__KEAP__.VUE_APP_STRIPE_ELEMENTS_URL,
        onStripeProcessedAnalytics: () => {},
    });
}
